import { Card, CardContent, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import type { InfoDisplay } from "../infoDisplaysTypes"
import { InfoDisplayCardMenu } from "./InfoDisplayCardMenu"
import { InfoDisplayThumbnail } from "./InfoDisplayThumbnail"

const useStyles = makeStyles()((theme) => ({
    card: {
        borderRadius: ".875rem",
    },
    name: {
        fontWeight: 700,
        color: theme.palette.tailwind.slate[700],
    },
    description: {
        color: theme.palette.tailwind.slate[500],
    },
}))

type Props = Readonly<{
    display: InfoDisplay
    isInactive: boolean
    onPreview: () => void
    onOpenLink: () => void
    onResetLink: () => void
    onToggleInactive: () => void
}>

/** One display on the info displays page: preview thumbnail, status, name and the card menu. */
export function InfoDisplayCard({ display, isInactive, onPreview, onOpenLink, onResetLink, onToggleInactive }: Props) {
    const { classes } = useStyles()

    return (
        <Card variant="outlined" className={classes.card}>
            <InfoDisplayThumbnail isInactive={isInactive} onPreview={onPreview} />
            <CardContent>
                <Stack direction="row" alignItems="flex-start" spacing=".5rem">
                    <Stack spacing=".3125rem" flexGrow={1} minWidth={0}>
                        <LocalizedStrict id={display.nameId}>
                            <Typography variant="subtitle1" className={classes.name}>
                                {display.nameFallback}
                            </Typography>
                        </LocalizedStrict>
                        <LocalizedStrict id={display.descriptionId}>
                            <Typography variant="body2" className={classes.description}>
                                {display.descriptionFallback}
                            </Typography>
                        </LocalizedStrict>
                    </Stack>
                    <InfoDisplayCardMenu
                        isInactive={isInactive}
                        onPreview={onPreview}
                        onOpenLink={onOpenLink}
                        onResetLink={onResetLink}
                        onToggleInactive={onToggleInactive}
                    />
                </Stack>
            </CardContent>
        </Card>
    )
}
